import request from '@/utils/request'

/**
 * 计算订单价格
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function computeOrderPrice(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.computeStoreOrderPrice',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 创建订单
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function createOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.saveStoreOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取地址列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listAddresses(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.queryUserAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存地址
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function saveAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.saveUserAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除地址
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deleteAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/userAddress.deleteUserAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取地区列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}